<template>
    <div class="templateOne templateOne_flex">
        <customHeader ref="customHeader"></customHeader>
        <contactInformation></contactInformation>
        <div ref="content" class="templateOne_content">
            <KeepRouterView></KeepRouterView>
        </div>

        <customFooter ref="customFooter"></customFooter>
    </div>
</template>

<script>
    import customHeader from "components/custom-header/custom-header.vue";
    import customFooter from "components/custom-footer/custom-footer.vue";
    import contactInformation from 'components/contactInformation/contactInformation.vue';
    // import menuConfig from "config/me_menu.config.js";
    // import pageConfig from "config/page.config.js";
    import KeepRouterView from "components/KeepRouterView/KeepRouterView.vue";
    // import MyBreadcrumb from "components/MyBreadcrumb/MyBreadcrumb.vue";
    import {mapGetters, mapMutations, mapActions} from 'vuex'
    // import * as api_common from '../../service/api/methods/api_common'
    // import {activeIndexData,breadcrumbRoute} from './data.config.js'

    export default {
        components: {
            customHeader,
            customFooter,
            KeepRouterView,
            contactInformation
        },
        computed: {
            ...mapGetters(['userInfo','isRefresh','menuList']),
            isFull(){//是否充满屏幕
                this.$nextTick(()=>{
                    let header=0;
                    let content=0;
                    let footer=0;
                    if(this.$refs.customHeader&&this.$refs.customHeader.$el){
                        header=this.$refs.customHeader.$el.offsetHeight||0;
                    }
                    if(this.$refs.content){
                        content=this.$refs.content.offsetHeight||0;
                    }
                    if(this.$refs.customFooter&&this.$refs.customFooter.$el){
                        footer=this.$refs.customFooter.$el.offsetHeight||0;
                    }
                    // console.log(header,content,footer,document.documentElement.clientHeight,(document.documentElement.clientHeight-header-content-footer)<=0);
                    return (document.documentElement.clientHeight-header-content-footer)<=0;
                });
            }
        },
        data() {
            return {
                scrollDis:20,//面包屑左边得距离
            };
        },
        watch:{
            // "$route":{
            //     handler(newRouter){
            //         this.isRefreshBreadcrumb = false;
            //         this.$nextTick(function(){
            //             this.isRefreshBreadcrumb = true;
            //         })
            //         // console.log("路由：",newRouter.path,this.editableTabsValue);
            //         let isHas=false;
            //         for (let index = 0; index < this.editableTabs.length; index++) {
            //             if(this.editableTabs[index].name==this.activeIndex){
            //                 isHas=true;
            //                 this.editableTabsValue = this.editableTabs[index].name;
            //                 this.setRouterKey(this.editableTabsValue,newRouter);
            //                 // console.log("有tab：",this.editableTabsValue);
            //                 break;
            //             }
            //         }
            //         //不存在
            //         if(!isHas){
            //             this.addTabOfMenus(this.menus,this.activeIndex,this.$route.path,true);
            //         }
            //     },
            //     immediate: true,//true刷新也会触发
            // },
            // menuList:{//菜单
            //     handler(newV){
            //         // console.log("菜单",newV);
            //         if(!this.$utils.isArrayEmpty(newV)){
            //             this.menus=newV;
            //             this.addTabOfMenus(this.menus,this.activeIndex,this.$route.path);
            //         }
            //     },
            //     immediate: true,//true刷新也会触发
            // },
        },
        created(){
        },
        methods: {
        }
    }
</script>

<style lang="less" scoped>
.templateOne{
    .templateOne_content{
        margin-top: @defalutHeaderHeight;
    }
}

.templateOne_flex{
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    .templateOne_content{
        flex: 1;
    }
}
</style>
